import type { AgentTeamMembershipIdentifiers } from '$agent-profiles';

/**
 * Returns a composite id composed of an agent's `id` and `teamId` in order to
 * distinguish between agents with the same `id` but different `teamId`s. If a
 * `teamId` is missing for whatever reason, only the agent's `id` will be used
 */
export function formatTeamMemberId(agentId: string, teamId: string | null) {
  if (teamId) {
    return `${agentId}:${teamId}`;
  }
  return agentId;
}

// Composite ids for every present legacy/identity pairing, so callers can
// match team memberships whether they hold legacy or identity ids. A missing
// user or team half yields no keys so malformed memberships never match.
export function formatTeamMemberIds(
  agent: Partial<AgentTeamMembershipIdentifiers>,
): string[] {
  const userIds = [agent.id, agent.userIdentityId].filter((id): id is string =>
    Boolean(id),
  );
  const teamIds = [agent.teamId, agent.teamIdentityId].filter(
    (id): id is string => Boolean(id),
  );

  if (!teamIds.length || !userIds.length) return [];

  return [
    ...new Set(
      userIds.flatMap((userId) =>
        teamIds.map((teamId) => formatTeamMemberId(userId, teamId)),
      ),
    ),
  ];
}
